export enum UpsertTypeEnum {
    Add = 'Add',
    Edit = 'Edit'
}